var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "simple-select" }, [
    _c(
      "select",
      _vm._g(_vm._b({}, "select", _vm.props, false), _vm.listeners),
      [_vm._t("default")],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }